import * as Highcharts from 'highcharts';
import 'highcharts/highcharts-more';
import 'highcharts/modules/boost';
import '../../highcharts-options';

import * as config from './config.json';
import * as utils from '../../../utils';

import { Aeroval } from '../../../types/global';
import { FairmodeData } from '../../../types/data';
declare var aeroval: Aeroval;


export function plotContingencyColumns(data: FairmodeData | undefined, observation: string, parameterDir: string, modelsDir: string[], layer: string, div: string, _chartOptions: any = {}): void {
	if (!data) return

	//time selection
	const keyTime = utils.getKeyTime(aeroval.time, aeroval.season);
	const TPData = []
	const TNData = []
	const FPData = []
	const FNData = []

	for (const modelDir of modelsDir) {

		const modelVar = Object.keys(data[parameterDir][observation][layer][modelDir])[0]
		const subData = data[parameterDir][observation][layer][modelDir][modelVar][keyTime]

		var TP = 0
		var TN = 0
		var FP = 0
		var FN = 0

		if (subData) {
			// loop over individual stations
			for (const station in subData) {
				if (Object.prototype.hasOwnProperty.call(subData, station)) {
					const stationData = subData[station];
					if (stationData) {
						// loop over individual data points
						TP += stationData.gap
						TN += stationData.gan
						FP += stationData.fa
						FN += stationData.ma
					}
				}
			}

			TPData.push(TP);
			TNData.push(TN);
			FPData.push(FP);
			FNData.push(FN);
		}
	}

	const series = [{
		name: 'True Positive',
		data: TPData,
		color: 'green'
	},
	{
		name: 'False Positive',
		data: FPData,
		color: 'orange'
	}, {
		name: 'False Negative',
		data: FNData,
		color: 'red'
	}] as any[]

	// set title
	const [titleText, titleFontSize] = getTitle(parameterDir);

	Highcharts.chart({
		chart: {
			renderTo: div,
			type: 'column',
			height: 400,
			width: 400,
			marginTop: _chartOptions.marginTop,
			marginBottom: _chartOptions.marginBottom,
			marginLeft: _chartOptions.marginLeft,
			marginRight: _chartOptions.marginRight,
		},
		title: {
			text: titleText,
			style: {
				fontSize: titleFontSize
			}
		},
		subtitle: {
			text: `Contingency charts - ${observation} - Thr: ${(config as any).exceedances[parameterDir]}`,
		},
		pane: {
			startAngle: 0,
			endAngle: 90,
		},
		xAxis: {
			categories: modelsDir
		},
		yAxis: [
			{
				min: 0,
				minorGridLineWidth: 1,
				title: {
					text: 'occurences',
				},
				gridLineWidth: 0,
				lineWidth: 0,
			}
		],
		tooltip: {
			valueDecimals: 2,
			headerFormat: '',
			pointFormat: '<b>{point.name}</b><br>station type: {point.type}<br>x: {point.x}<br>y: {point.y}',
		},
		legend: {
			floating: false,
			verticalAlign: 'bottom',
			align: 'left'
		},
		series: series,
		plotOptions: {
			series: {
				dataLabels: {
					enabled: true
				}
			}
		}
	})
}

function getTitle(parameterDir: string): [string, string] {
	const parameterName = aeroval.menu[parameterDir].name
	var title = `${parameterName} - ${aeroval.region} - ${aeroval.time}`;
	if (aeroval.season !== 'All') {
		title += ` (${aeroval.season})`;
	}
	const fontSize = title.length >= 40 ? '16px' : '14px';
	return [title, fontSize];
}
